import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchBanks, selectBankState } from "../redux/slices/bankSlice"
import { ApiStatus } from "../types/api/status"
import { BankAPI } from "../apis/BankAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useBankStore = () => {
    const dispatch = useDispatch()
    const { banks, bankSelected, status } = useSelector(selectBankState)

    const getBanks = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BankAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "")
                return false
            }
            const { detail } = response.data
            dispatch(onFetchBanks(detail || []))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return true
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        banks,
        bankSelected,
        status,
        getBanks
    }
}